module.exports = __webpack_public_path__ + "Onboardingdesign3.svg?638c38fd4f26a8b0daa7d7c5a29e8be7";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Onboardingdesign3.svg
// module id = 82
// module chunks = 0